<template lang="pug">
  r-table(
    no-filter
    no-search
    ref='table'
    v-bind='tableProps'
    @detail='submitUpdate'
    @remove='submitDelete'
    )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import GBranchOfficeHeaders from '@/views/General/GBranchOffice/GBranchOfficeHeaders'
  import GBranchOfficeModel from '@/models/General/GBranchOffice'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          headers: GBranchOfficeHeaders,
          service: GBranchOfficeModel,
        }
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    methods: {
      showDeleteError() {
        this.$toast.error('Error al eliminar sucursal.')
      },
      showDeleteSuccess() {
        this.$toast.success('Sucursal eliminada exitosamente.')
      },
      submitCreate() {
        this.$router.push({ name: 'g-branch-office-create' })
      },
      submitDelete(event) {
        this.selected = event.item
        this.$toast.confirm("¿Confirma la eliminación de la sucursal seleccionada?", this.$toaster(this, this.toDelete))
      },
      submitUpdate(event) {
        this.$router.push({ name: 'g-branch-office-update', params: { id: event.item.id } })
      },
      toDelete() {
        return this
          .selected
          .delete()
          .then(this.showDeleteSuccess)
          .then(this.toRefresh)
          .catch(this.showDeleteError)
      },
      toRefresh() {
        return this
          .$refs
          .table
          .refresh()
      }
    },
    created() {
      this.setTitle('Sucursales')
      this.setItems([
        {
          action: this.submitCreate,
          color: 'accent',
          text: 'sucursal',
          icon: 'add_circle',
        },
      ])
    },
  }
</script>